import ViewModelCore from "./ViewModel";

export default class PedidoAndamentoViewModel extends ViewModelCore {
    constructor () {
        super();
        this.NumeroPedido = undefined;
        this.NumeroDaSolicitacao = undefined;
        this.NumeroParcela = undefined;
        this.NomeProduto = undefined;
        this.ProdutoNovo = undefined;
        this.Codigo = undefined;
        this.IndicadorPedidoParcela = undefined;
        this.Unidade = undefined;
        this.Representante = undefined;
        this.Cliente = undefined;
        this.PeriodoEntregaInicio = undefined;
        this.PeriodoEntregaFim = undefined;
        this.PeriodoCarregamentoInicio = undefined;
        this.PeriodoCarregamentoFim = undefined;
        this.ConsultarDadosClienteAgrupador = undefined;
        this.ComponentesExpandidos = undefined;
        this.Status = null;
    }
    
}